/**
 * Tabs — 显示模式切换（对照/混排/原文/译文）
 */

import { ReactNode } from 'react';

export interface Tab {
  id: string;
  label: string;
  icon?: ReactNode;
}

export interface TabsProps {
  tabs: Tab[];
  activeId: string;
  onChange: (id: string) => void;
  className?: string;
}

export function Tabs({ tabs, activeId, onChange, className = '' }: TabsProps) {
  return (
    <div
      className={`inline-flex items-center gap-1 rounded-lg bg-warm-white dark:bg-warm-dark p-1 ${className}`}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={`inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
            activeId === tab.id
              ? 'bg-camel text-white'
              : 'text-charcoal dark:text-charcoal-light hover:bg-white dark:hover:bg-border-warm-dark'
          }`}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );
}
